// extracted by mini-css-extract-plugin
export var content = "_qn-1";
export var fullScreen = "_qn-0";